const i = {
  sm: {
    width: "8",
    height: "8",
    padding: "spacing-2"
  },
  md: {
    width: "11",
    height: "11",
    padding: "spacing-3"
  },
  lg: {
    width: "14",
    height: "14",
    padding: "spacing-3.5"
  }
}, h = {
  sm: {
    width: 16,
    height: 16
  },
  md: {
    width: 16,
    height: 16
  },
  lg: {
    width: 24,
    height: 24
  },
  xl: {
    width: 24,
    height: 24
  }
};
export {
  h as iconSize,
  i as size
};
